module.exports = __webpack_public_path__ + "static/media/flyer2.efe85acc.png";